import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table from './Table.jsx'
//import _ from 'lodash'

class PublicHolidayComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.publicholidays.everyyear) {
      return <div><Table publicholidays={this.props.publicholidays}></Table></div>
    }
    return <div></div>
  }
}

PublicHolidayComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  publicholidays: PropTypes.object.isRequired,
}

export default PublicHolidayComponent
